import Vue from 'vue'
import Router from 'vue-router'
import BootstrapVue from 'bootstrap-vue'

import Home from '@/components/pages/Home'
import PaginaEmpresa from '@/components/pages/PaginaEmpresa'
import PaginaSocial from '@/components/pages/PaginaSocial'
import PaginaContato from '@/components/pages/PaginaContato'
import PaginaNfe from '@/components/pages/PaginaNfe'
import PaginaDownloads from '@/components/pages/PaginaDownloads'
import PaginaTrabalheConosco from '@/components/pages/PaginaTrabalheConosco'
import PaginaTrabalheConoscoLogin from '@/components/pages/PaginaTrabalheConoscoLogin'
import PaginaRepresentantes from '@/components/pages/PaginaRepresentantes'
import PaginaProdutos from '@/components/pages/PaginaProdutos'
import Teste from '@/components/Teste'

import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import VueCarousel from 'vue-carousel';
import VModal from 'vue-js-modal'

Vue.use(Router)
Vue.use(BootstrapVue)
Vue.use(VueCarousel)
Vue.use(VModal)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home
    },
    {
      path: '/empresa',
      name: 'Empresa',
      component: PaginaEmpresa
    },
    {
      path: '/social',
      name: 'Social',
      component: PaginaSocial
    },
    {
      path: '/contato',
      name: 'Contato',
      component: PaginaContato
    },
    {
      path: '/nfe',
      name: 'NFe',
      component: PaginaNfe
    },
    {
      path: '/downloads',
      name: 'Downloads',
      component: PaginaDownloads
    },
    {
      path: '/trabalhe-conosco',
      name: 'Trabalhe Conosco',
      component: PaginaTrabalheConosco
    },
    {
      path: '/trabalhe-conosco/login',
      name: 'Login - Trabalhe Conosco',
      component: PaginaTrabalheConoscoLogin
    },
    {
      path: '/representantes',
      name: 'Representantes',
      component: PaginaRepresentantes
    },
    {
      path: '/produtos',
      name: 'Produtos',
      component: PaginaProdutos
    },
    {
      path: '/teste',
      name: 'Teste',
      component: Teste
    },
  ]
})




// WEBPACK FOOTER //
// ./src/router/index.js